import { jsx as _jsx } from "react/jsx-runtime";
import Modal from '../Modal';
import ClienteForm from './ClienteForm';
const ClienteModal = ({ isOpen, onClose, cliente, onSave, isLoading = false }) => {
    const handleSave = (savedCliente) => {
        onSave(savedCliente);
        onClose();
    };
    return (_jsx(Modal, { isOpen: isOpen, onClose: onClose, title: cliente ? 'Editar Cliente' : 'Novo Cliente', size: "2xl", children: _jsx("div", { className: "max-h-[80vh] overflow-y-auto", children: _jsx(ClienteForm, { cliente: cliente, onSave: handleSave, onCancel: onClose, isLoading: isLoading }) }) }));
};
export default ClienteModal;
